<template>
<section class="layout-header" :style="{
  'padding-top': `${-showHeader & 46}px`
}">
  <section v-if="showHeader" class="layout-header-info">
    <h1 class="system-name">{{SYSTEM_NAME.cnName}}</h1>
    <layout-user />
  </section>

  <section class="layout-header-nav-wrapper">
    <layout-main-nav :line-height="navLineHeight" />
  </section>
</section>
</template>

<script>
import BaseStore from '../BaseStore'
import LayoutUser from './User'
import LayoutMainNav from './MainNav'

export default {
  name: 'LayoutHeader',
  components: {LayoutMainNav, LayoutUser},
  extends: BaseStore,
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    navLineHeight: {
      type: String
    }
  },
  computed: {
    SYSTEM_NAME: () => process.env.SYSTEM_NAME
  }
}
</script>

<style lang="scss" scoped>
.layout-header {
  $INFO-HEIGHT: 46px;
  $COMMON-PADDING: 20px;

  padding-top: $INFO-HEIGHT;
  color: #ffffff;
  /*background-color: #409eff;*/
  /*background-color: #66b1ff;*/
  background: radial-gradient(ellipse at center, #29387d 0%, #1a234f 100%);
  z-index: 12;
  user-select: none;

  > .layout-header-info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $INFO-HEIGHT;
    line-height: $INFO-HEIGHT;
    padding: 0 $COMMON-PADDING;
  }

  > .layout-header-nav-wrapper {
    font-size: .875rem;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 $COMMON-PADDING;
    /*background-color: #3c8dbc;*/
    /*background-color: #545c64;*/
    /*background-color: rgba(0, 255, 0, .15);*/
    /*background-color: #0e82b9;*/
    /*background-color: #3c8dbc;*/
    background-color: #2d3d88;
  }
}

.layout-header-info {
  > .system-name {
    font-size: 1.25rem;
    float: left;
    margin: 0;
    text-shadow: 0 0 4px rgba(0, 0, 0, .15);
  }

  > .user {
    float: right;
    font-size: .875rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Header.vue